import dynamic from 'next/dynamic';
import React from 'react';

import { fontFamilies } from 'components/UI/Font';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { Product } from 'models/product';
import { SearchResult } from 'models/search';

import { MoreProductsCard } from './MoreProductsCard';
import { RelatedProductCard } from './RelatedProductCard';

const NukaCarousel = dynamic(import(/* webpackChunkName: "nuka-carousel" */ 'nuka-carousel'));

export const Carousel: React.FC<{
  department: string;
  product: Product;
  products: SearchResult[];
}> = ({
  department,
  product: {
    brand: { name: brandName, url: brandUrl },
  },
  products,
}) => {
  const { withCDN } = useUrlBuilder();

  const productCards = [
    ...products.map(product => <RelatedProductCard product={product} />),
    <MoreProductsCard brandName={brandName} brandUrl={brandUrl} department={department} />,
  ];

  return (
    <>
      <div className="carousel">
        <h4 className="title">
          More from <span>{brandName}</span>
        </h4>

        <div className="instructions mobile">
          Slide to scroll
          <img src={withCDN('mkt/icon/arrow_right_grey.png')} />
        </div>

        <div className="mobile-flex products-row">{productCards}</div>

        <div className={'desktop products-row'}>
          <NukaCarousel
            framePadding="0 50px"
            initialSlideHeight={351}
            renderBottomCenterControls={null}
            renderCenterLeftControls={({ previousSlide }) => (
              <span className="slider-arrow icon-angle-left" onClick={previousSlide} />
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <span className="slider-arrow icon-angle-right" onClick={nextSlide} />
            )}
            slidesToScroll="auto"
            slidesToShow={4}
            wrapAround
          >
            {productCards}
          </NukaCarousel>
        </div>
      </div>

      <style jsx>{`
        .carousel {
          margin: 40px 0 50px 0;
        }
        @media (min-width: 1024px) {
          .carousel {
            margin: 40px 0 0 0;
          }
        }

        .title {
          font-family: ${fontFamilies.bold};
          font-size: 15px;
          padding-bottom: 5px;
          border-bottom: 2px solid #eceeef;
          margin-bottom: 35px;
        }
        .title > span {
          text-transform: uppercase;
          font-family: inherit;
        }

        .instructions {
          color: #999;
          text-align: right;
          user-select: none;
          font-size: 13px;
        }
        .instructions > img {
          width: 10px;
          height: auto;
          padding-left: 3px;
        }

        .products-row.desktop-flex {
          height: 300px;
        }

        .products-row.mobile-flex {
          align-items: center;
          overflow-x: scroll;
          overflow-y: hidden;
          user-select: none;
          width: 100%;
          padding-top: 50px;
        }

        .slider-arrow {
          font-size: 40px;
          font-weight: 100;
          color: #aaa;
          cursor: pointer;
        }
        .slider-arrow:hover {
          color: #000;
        }
      `}</style>
    </>
  );
};
